import { ApplicationBaseData, ApplicationStage } from "common";
import { BrokerStatus } from "@partner/shared/SharedConstants";
import { ApplicationData } from "../../domain/models/application.model";

export interface ApplicationResponse extends ApplicationBaseData {
  requestedAmount?: number;
  incompleteInfo?: string;
  declinedReason?: string;
  previousStage?: ApplicationStage;
  brokerStatus: BrokerStatus;
  lostReason?: string;
  lostReasonAdditionalComments?: string;
  statusChangedOnDate?: string | Date;
  hasOutsideFiles: boolean;
}

export const adaptApplicationData = (data: ApplicationResponse): ApplicationData => {
  return {
    ...data,
    advisorId: data.advisorId,
    statusChangedOnDate: data?.statusChangedOnDate ? new Date(data?.statusChangedOnDate) : undefined
  }
}
